<template>
  <div
    class="evaluation-comment"
    v-if="item"
    :class="{open:isOpen}">
    <header>
      <h4>Comentario</h4>
      <h5>{{ item.name }}</h5>
      <p>Escriba un comentario sobre la sección o la pregunta</p>
      <button
        class="button-close"
        @click="close">
        <i class="icon-close"/>
      </button>
    </header>
    <main>
      <el-form>
        <el-form-item>
          <wysiwyg
            v-if="isOpen"
            v-model="item.comment"
            :options="editorOptions"
          />
        </el-form-item>
        <div class="controls">
          <el-button
            @click="close"
          >
            Cancelar
          </el-button>
          <el-button
            type="primary"
            @click="close"
          >
            Guardar
          </el-button>
        </div>
      </el-form>
    </main>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
export default {
  name: 'EvaluationComment',
  props: {
    item: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      editorOptions: {
        hideModules: {
          justifyLeft: true,
          justifyCenter: true,
          justifyRight: true,
          headings: true,
          link: true,
          code: true,
          orderedList: true,
          unorderedList: true,
          image: true,
          table: true,
          removeFormat: true
        }
      },
      isOpen: false
    }
  },
  methods: {
    open () {
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.evaluation-comment {
  background-color: #fff;
  box-shadow: 0 -5px 10px -5px rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: -100vh;
  left: 0;
  width: 100%;
  opacity: 0;
  transition: all 0.5s ease-in-out;
  z-index: 1002;
  &.open {
    bottom: 0;
    opacity: 1;
  }
  header {
    padding: 20px;
    h4 {
      margin: 0;
      @include font-primary(14px, bold);
    }
    .button-close {
      position: absolute;
      height: 40px;
      width: 40px;
      background-color: #fff;
      border: none;
      top: 0;
      right: 0;
      font-size: 14px;
    }
  }
  main {
    padding: 0 20px 10px 20px;
    .controls {
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/layout/evaluation-comment.vue